import { render, staticRenderFns } from "./ebooksTip.vue?vue&type=template&id=3ef69fbb&scoped=true&"
import script from "./ebooksTip.vue?vue&type=script&lang=js&"
export * from "./ebooksTip.vue?vue&type=script&lang=js&"
import style0 from "./ebooksTip.vue?vue&type=style&index=0&id=3ef69fbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef69fbb",
  null
  
)

component.options.__file = "ebooksTip.vue"
export default component.exports